import React from "react";
import { MessageCircle, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { businessInfo } from "../constants";

export default function StickyMobileCTA() {
  return (
    <>
      <a href={businessInfo.whatsapp} target="_blank" rel="noreferrer" className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-[#25D366] text-white grid place-items-center shadow-lg hover:bg-[#1eb955] pulse-ring transition-colors" aria-label="WhatsApp">
        <MessageCircle className="w-7 h-7" />
      </a>
      {/* Mobile sticky bar */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-neutral-200 shadow-[0_-6px_16px_rgba(0,0,0,0.06)]">
        <div className="grid grid-cols-3 divide-x divide-neutral-200">
          <a href={`tel:${businessInfo.phone}`} className="flex items-center justify-center gap-2 py-3.5 text-sm font-semibold text-[#0f172a]">
            <Phone className="w-4 h-4 text-[#e30613]" /> Call
          </a>
          <a href={businessInfo.whatsapp} target="_blank" rel="noreferrer" className="flex items-center justify-center gap-2 py-3.5 text-sm font-semibold text-[#0f172a]">
            <MessageCircle className="w-4 h-4 text-[#25D366]" /> WhatsApp
          </a>
          <Link to="/book-service" className="flex items-center justify-center gap-2 py-3.5 text-sm font-semibold text-white bg-[#e30613]">
            Book Service
          </Link>
        </div>
      </div>
      <div className="md:hidden mobile-cta-spacer" />
    </>
  );
}
